/**
 * @fileoverview Vehicles theme - match vehicle emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

/**
 * Vehicles theme with car, truck, and bus emojis.
 */
export class VehiclesTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'vehicles',
            'Vehicles',
            allLabels.vehicles,
            { numPairs: 4, isPremium: false, hasMovement: false, ...options }
        );
    }
}
